import React, { useState } from 'react';
import { call, put, takeEvery } from 'redux-saga/effects';
import { Link } from 'react-router-dom';
import {
  SystemTenantTable,
  mountTable,
  unmountTable,
  refetchTable,
} from '@kineticdata/react';
import { generateEmptyBodyRow, Icon, FilterToggle } from '@kineticdata/ui';
import { regSaga, regRoute } from '../../store';
import { ActionsHeaderCell } from '../common/tables/ActionsHeaderCell';
import { StatusBadge } from '../common/StatusBadge';

const tableKey = 'tenant-table';

regRoute('TENANTS_LIST_PAGE', '/spaces');

regSaga(
  takeEvery('ENTER_TENANTS_LIST_PAGE', function*() {
    yield call(mountTable, tableKey);
    yield put({ type: 'SET_CAN_DELETE_TASK_DB', payload: true });
  }),
);
regSaga(
  takeEvery('LEAVE_TENANTS_LIST_PAGE', function*() {
    yield call(unmountTable, tableKey);
  }),
);

const NameCell = props => (
  <td>
    <Link to={`/spaces/edit/${props.row.get('slug')}`}>{props.value}</Link>
  </td>
);

const StatusCell = props => (
  <td>
    <StatusBadge value={props.value} />
  </td>
);

const StatusMessageCell = props => <td>{props.value || <em>None</em>}</td>;

const ActionsCell = props => (
  <td>
    <Link
      className="btn btn-table"
      to={`/spaces/edit/${props.row.get('slug')}`}
      aria-label="Edit"
      title="Edit"
    >
      <Icon name="edit-2" md />
    </Link>
  </td>
);

const EmptyBodyRow = generateEmptyBodyRow({
  loadingMessage: 'Loading Spaces...',
  noSearchResultsMessage:
    'No Spaces were found - please modify your search criteria',
  noItemsMessage: 'There are no Spaces to display.',
  noItemsLinkTo: '/spaces/new',
  noItemsLinkToMessage: 'Add new Space',
});

const handleRefresh = () => refetchTable(tableKey);

export const SpaceList = () => {
  const [filterOpen, setFilterOpen] = useState(false);

  return (
    <SystemTenantTable
      tableKey={tableKey}
      columnSet={[
        'space.name',
        'slug',
        'space.status',
        'space.statusMessage',
        '_actions',
      ]}
      alterColumns={{
        'space.name': { components: { BodyCell: NameCell } },
        'space.status': { components: { BodyCell: StatusCell } },
        'space.statusMessage': { components: { BodyCell: StatusMessageCell } },
      }}
      addColumns={[
        {
          value: '_actions',
          title: '',
          sortable: false,
          components: { BodyCell: ActionsCell, HeaderCell: ActionsHeaderCell },
        },
      ]}
      filterSet={['space.name', 'slug']}
      components={{ EmptyBodyRow }}
      renderOptions={{ canDeleteDb: true }}
      filterAutoFocus={0}
    >
      {({ pagination, table, filter, filterFormKey, appliedFilters }) => (
        <div className="app-content__main">
          <div className="heading">
            <h1>Spaces</h1>
            <div className="btn-set">
              <FilterToggle
                isOpen={filterOpen}
                setOpen={setFilterOpen}
                filterFormKey={filterFormKey}
                appliedFilters={appliedFilters}
              />
              <button
                className="btn btn-outline-primary"
                type="button"
                onClick={handleRefresh}
                aria-label="Refresh"
                title="Refresh"
              >
                <Icon name="refresh-cw" />
              </button>
              <Link className="btn btn-primary" to="/spaces/new">
                <Icon name="plus" />
                <span>New Space</span>
              </Link>
            </div>
          </div>
          <div className="content-container">
            {filterOpen && filter}
            {table}
            {pagination}
          </div>
        </div>
      )}
    </SystemTenantTable>
  );
};
